import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../../components/shapes/Line'
import { SmallText } from '../../../../components/presentation/Text'
import GalleryInput from '../../../../components/form/GalleryInput'
import Separator from '../../../../components/helpers/Separator'

const ReplyNotesInput = ({ value, open, handleChange }) => {
  if (!open) return false

  return (
    <div>
      <Separator weight={4} />
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={4} />
      <SmallText size="xsmall">Fotos</SmallText>
      <Separator />
      <GalleryInput useRotation value={value} onChange={handleChange} />
    </div>
  )
}

export default ReplyNotesInput
